import { createSelector } from 'reselect';


const rootSelector = (state: State.Root) => state.pickLists;

export const pickListsLoadingSelector = createSelector(
  rootSelector,
  (pickLists: State.PickListsState) => pickLists.loading
);

export const pickListsErrorSelector = createSelector(
  rootSelector,
  (pickLists: State.PickListsState) => pickLists.error
);

export const getPickListByIdSelector = (pickListId: string) =>
  createSelector(rootSelector, (pickLists: State.PickListsState) =>
    pickLists.pickLists[pickListId] ? pickLists.pickLists[pickListId] : null
  );
